import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { logout } from '../../actions/auth';
import { Redirect } from 'react-router-dom';

const Logout = ({ auth: { user, loading }, logout }) => {


useEffect(() => {
    logout()
  }, []);


    return (
      <Redirect to="/" />
    )
};

Logout.propTypes = {
  auth: PropTypes.object.isRequired,
  logout: PropTypes.func.isRequired
}

const mapStateToProps = state => ({
    auth: state.auth
});

export default connect(mapStateToProps, { logout })(Logout);